import BACKGROUND_LOGIN from '../assets/images/background-login.png'
import LOGO from '../assets/images/newsad-yoko 1.png'
import LOGO_LOGIN from '../assets/images/newsad-tate 1.png'
import LOADING_BACKGROUND from '../assets/images/loading-background.png'

export const images = {
  BACKGROUND_LOGIN,
  LOGO,
  LOGO_LOGIN,
  LOADING_BACKGROUND,
}
